




export default {
  props: {
    text: {
      type: [String, null],
      default: '',
    },
    type: {
      type: String,
      default: 'neutral',
    },
  },
  computed: {
    noBreakText() {
      return this.text ? this.text.replace(/\s/g, '&nbsp;') : ''
    },
  },
}
